/* youtube-embed.js — 把 RTE 里的占位容器替换为真实 YouTube 播放器 */
(function () {
  function ready(fn){
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn, { once:true });
  }

  function mountNode(holder){
    if (!holder || holder.dataset.mounted === '1') return;
    var id = holder.dataset.id; if (!id) return;

    var start = parseInt(holder.dataset.start || '0', 10) || 0;
    var ratio = (holder.dataset.ratio || '').replace('x','/'); // 如 "4x3"
    var maxw  = holder.dataset.maxwidth || '';                  // 如 "720" 或 "720px" 或 "80%"
    var cover = /^(1|true|yes)$/i.test(holder.dataset.cover || '');
    var title = holder.dataset.title 
             || (holder.querySelector && holder.querySelector('a') && holder.querySelector('a').textContent.trim())
             || 'YouTube video player';

    // 新容器，继承 CSS 变量（含样式表里定义的值）
    var box = document.createElement('div');
    box.className = 'youtube-embed';

    ['--yt-ratio','--yt-maxw','--yt-btn-w','--yt-btn-h'].forEach(function(v){
      var val = getComputedStyle(holder).getPropertyValue(v);
      if (val) box.style.setProperty(v, val.trim());
    });
    if (ratio) box.style.setProperty('--yt-ratio', ratio);
    if (maxw)  box.style.setProperty('--yt-maxw', /^\d+$/.test(maxw) ? (maxw + 'px') : maxw);
    if (cover) box.classList.add('is-cover');

    // 封面缩略图
    var thumb = document.createElement('div');
    thumb.className = 'youtube-embed__thumb';
    thumb.style.backgroundImage = 'url(https://i.ytimg.com/vi/' + id + '/hqdefault.jpg)';

    // 播放按钮：点击后创建 iframe
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'youtube-embed__play';
    btn.setAttribute('aria-label','Play video');

    btn.addEventListener('click', function(){
      var iframe = document.createElement('iframe');
      var qs = new URLSearchParams({
        rel: '0',
        modestbranding: '1',
        playsinline: '1',
        autoplay: '1'
      });
      if (start) qs.set('start', String(start));

      iframe.src = 'https://www.youtube-nocookie.com/embed/' + id + '?' + qs.toString();
      iframe.title = title;
      iframe.loading = 'lazy';
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen = true;

      box.replaceChildren(iframe);   // 清空缩略图和按钮，换成播放器
    }, { once:true });

    box.appendChild(thumb);
    box.appendChild(btn);

    // 用真正容器替换占位（占位 <a> 会一并被移除；JS 未运行时它作为兜底链接）
    holder.replaceWith(box);
    holder.dataset.mounted = '1';
  }

  function mountAll(root){
    (root || document).querySelectorAll('.youtubevideo[data-id]').forEach(mountNode);
  }

  // 初始挂载 + 异步兜底
  ready(function(){
    mountAll();
    setTimeout(mountAll, 300);
  });

  // 监听后续异步插入的内容（如分段加载、切换 tab 后加载等）
  if ('MutationObserver' in window){
    var obs = new MutationObserver(function(muts){
      muts.forEach(function(m){
        (m.addedNodes||[]).forEach(function(n){
          if (n && n.nodeType === 1) mountAll(n);
        });
      });
    });
    obs.observe(document.documentElement, { childList:true, subtree:true });
  }
})();
